var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.93,10.14v10.58c0,0.14-0.09,0.28-0.23,0.33c-0.05,0.02-0.1,0.03-0.15,0.03c-0.1,0-0.19-0.04-0.27-0.11 l-4.31-4.08c-0.07-0.07-0.11-0.16-0.11-0.25v-6.5c0-0.2,0.18-0.36,0.38-0.36h4.31C44.76,9.78,44.93,9.94,44.93,10.14z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.13,
    y: 7.97,
    className: "st0",
    width: 6.52,
    height: 2.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.65,10.51h-6.52c-0.2,0-0.36-0.16-0.36-0.36V7.97c0-0.2,0.16-0.36,0.36-0.36h6.52 c0.2,0,0.36,0.16,0.36,0.36v2.17C46.01,10.35,45.85,10.51,45.65,10.51z M39.49,9.78h5.8V8.33h-5.8V9.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "46.74,23.19 46.74,46.38 11.96,46.38 11.96,23.19  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.74,46.74H11.96c-0.2,0-0.36-0.16-0.36-0.36V23.19c0-0.2,0.16-0.36,0.36-0.36s0.36,0.16,0.36,0.36v22.83 h34.06V23.19c0-0.2,0.16-0.36,0.36-0.36c0.2,0,0.36,0.16,0.36,0.36v23.19C47.1,46.58,46.94,46.74,46.74,46.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.81,36.83l0,9.91h-9.42V36.67c0-3.01,2.96-5.33,6.2-4.37C25.54,32.89,26.81,34.79,26.81,36.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.57,23.19 8.45,23.19 29.01,5.16  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.57,23.55H8.45c-0.15,0-0.29-0.09-0.34-0.23c-0.05-0.14-0.01-0.3,0.1-0.4L28.77,4.89 c0.14-0.12,0.34-0.12,0.48,0l20.57,18.03c0.11,0.1,0.15,0.26,0.1,0.4C49.86,23.46,49.72,23.55,49.57,23.55z M9.41,22.83h39.2 L29.01,5.64L9.41,22.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.64,46.74H8.33c-0.2,0-0.36-0.16-0.36-0.36c0-0.2,0.16-0.36,0.36-0.36h41.3c0.2,0,0.36,0.16,0.36,0.36 C50,46.58,49.84,46.74,49.64,46.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.13,15.59c0,1.73-1.4,3.13-3.13,3.13c-1.72,0-3.13-1.4-3.13-3.13c0-1.72,1.4-3.12,3.13-3.12 C30.73,12.47,32.13,13.87,32.13,15.59z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,40.22c-0.2,0-0.36-0.16-0.36-0.36v-1.45c0-0.2,0.16-0.36,0.36-0.36s0.36,0.16,0.36,0.36v1.45 C25.36,40.06,25.2,40.22,25,40.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,33.7h-4.35v-4.35h4.35V33.7z M36.96,29.35v4.35h-4.35v-4.35H36.96z M32.61,34.42h4.35v4.35h-4.35 V34.42z M36.96,38.77v-4.35h4.35v4.35H36.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,4.68v1.84H0.36V4.68c0-0.58,0.47-1.06,1.06-1.06h13.83C15.83,3.62,16.3,4.1,16.3,4.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,6.88H0.36C0.16,6.88,0,6.72,0,6.52V4.68C0,3.9,0.64,3.26,1.42,3.26h13.83c0.78,0,1.42,0.64,1.42,1.42 v1.84C16.67,6.72,16.5,6.88,16.3,6.88z M0.72,6.16h15.22V4.68c0-0.38-0.31-0.69-0.69-0.69H1.42c-0.38,0-0.69,0.31-0.69,0.69V6.16 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.36,
    y: 6.52,
    className: "st0",
    width: 15.94,
    height: 21.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,27.9H0.36C0.16,27.9,0,27.74,0,27.54V6.52c0-0.2,0.16-0.36,0.36-0.36H16.3c0.2,0,0.36,0.16,0.36,0.36 v21.01C16.67,27.74,16.5,27.9,16.3,27.9z M0.72,27.17h15.22V6.88H0.72V27.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,27.54v1.84c0,0.58-0.47,1.06-1.06,1.06H1.42c-0.58,0-1.06-0.47-1.06-1.06v-1.84H16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.25,30.8H1.42C0.64,30.8,0,30.16,0,29.38v-1.84c0-0.2,0.16-0.36,0.36-0.36H16.3 c0.2,0,0.36,0.16,0.36,0.36v1.84C16.67,30.16,16.03,30.8,15.25,30.8z M0.72,27.9v1.48c0,0.38,0.31,0.69,0.69,0.69h13.83 c0.38,0,0.69-0.31,0.69-0.69V27.9H0.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.06,29.35H6.88c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h2.17c0.2,0,0.36,0.16,0.36,0.36 S9.26,29.35,9.06,29.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.24,14.88c-0.19,0.13-0.38,0.25-0.57,0.39c0,0-0.01,0-0.01,0.01v14.09c0,0.79-0.64,1.43-1.43,1.43h-3.67 v0.72h3.67c1.19,0,2.15-0.96,2.15-2.15v-14.6C17.34,14.81,17.29,14.85,17.24,14.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.06,5.43H7.61c-0.2,0-0.36-0.16-0.36-0.36c0-0.2,0.16-0.36,0.36-0.36h1.45c0.2,0,0.36,0.16,0.36,0.36 C9.42,5.27,9.26,5.43,9.06,5.43z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.55,20.23c0.05,0.28-0.04,0.57-0.22,0.79c-0.2,0.23-0.49,0.36-0.78,0.36h-0.1c-0.2,0-0.36-0.17-0.36-0.36 c0-2.01-1.64-3.64-3.64-3.64c-0.2,0-0.36-0.17-0.36-0.36v-0.11c0-0.3,0.13-0.58,0.35-0.77c0.22-0.2,0.52-0.28,0.8-0.24 C8.47,16.25,10.2,17.99,10.55,20.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.3,20.25v0.08c0,0.26-0.09,0.52-0.27,0.72c-0.19,0.21-0.46,0.33-0.74,0.33h-0.12 c-0.2,0-0.36-0.17-0.36-0.36c0-3.51-2.86-6.36-6.37-6.36c-0.2,0-0.36-0.16-0.36-0.36v-0.12c0-0.29,0.12-0.55,0.33-0.75 c0.21-0.19,0.51-0.29,0.79-0.26C9.95,13.52,12.94,16.5,13.3,20.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.55,19.99c0.15,0.31,0.14,0.68-0.05,0.98c-0.19,0.3-0.51,0.48-0.86,0.48c-0.2,0-0.36-0.17-0.36-0.36 c0-0.51-0.41-0.92-0.92-0.92c-0.2,0-0.36-0.17-0.36-0.36c0-0.56,0.46-1.01,1.01-1.01c0.17,0,0.32,0.04,0.46,0.12 C6.93,19.13,7.31,19.52,7.55,19.99C7.55,19.98,7.55,19.98,7.55,19.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAutomation);
export default __webpack_public_path__ + "static/media/home-automation.7fd21a135ea5cb4fb40480d3e556bd44.svg";
export { ForwardRef as ReactComponent };